/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { MinutesCalculate } from "../../utils/generalLiveCenter";


const MatchMinutes = ({ match, cssclass }) => {
  const removeCh = ["45+", "HT", "90+", "105+", "120+"];
  const [currentMint, setCurrentMint] = useState(() =>
    MinutesCalculate(match?.sun, match?.sut, match?.im, match?.mins, match?.id)
  );

  const [showTick, setShowTick] = useState(true);

  useEffect(() => {
    setCurrentMint(
      MinutesCalculate(match?.sun, match?.sut, match?.im, match?.mins, match?.id)
    );

    if (match?.sun?.toLowerCase() === "finished") return;

    const intervalId = setInterval(() => {
      const next = MinutesCalculate(
        match?.sun,
        match?.sut,
        match?.im,
        match?.mins,
        match?.id
      );

      setCurrentMint(next);
      if (next === "FT") clearInterval(intervalId);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [match]);

  useEffect(() => {
    const blinkId = setInterval(() => {
      setShowTick((prev) => !prev);
    }, 1000);
    return () => clearInterval(blinkId);
  }, []);

  return (
    <span className={cssclass}>
      {currentMint}
      {currentMint && !removeCh.includes(currentMint) && (
        <span style={{ visibility: showTick ? "visible" : "hidden" }}>
          &lsquo;
        </span>
      )}
    </span>
  );
};

export default MatchMinutes;
